import { Stack, StackProps } from '@mui/material';
import { ElementType } from 'react';

import LinkUnstyled from 'components/@common/LinkUnstyled';

const BorderStack = <T extends ElementType = typeof LinkUnstyled | 'div'>({
  children,
  component,
  sx,
  ...rest
}: StackProps<T>) => {
  return (
    <Stack
      component={component}
      {...rest}
      sx={[
        (theme) => ({
          border: `1px solid ${theme.vars.palette.divider}`,
          textAlign: 'start',
          borderRadius: 4,
          padding: 2,
          textDecoration: 'none',
          '&:hover, &:active': {
            textDecoration: 'none',
          },
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Stack>
  );
};

export default BorderStack;
